import { CreditCardIcon, EyeIcon, UserIcon, UserPlusIcon, VideoCameraIcon } from '@heroicons/react/24/solid'
import moment from 'moment/moment';
import React from 'react'
import { Link, useLoaderData, useNavigate } from 'react-router-dom'

export default function Dashboard() {
  const data = useLoaderData();
  const navigate = useNavigate();
  return (
    <div className="w-full">
      <h4 className="text-xl font-fira font-semibold">Dashboard</h4>
      <div className="mt-4 grid md:grid-cols-4 xl:gap-6 gap-2 grid-cols-2">
        <div className="bg-white cursor-pointer relative py-4 px-3 rounded-lg border-2 border-gray-300 shadow-sm">
          <h4 className="text-lg font-semibold text-gray-900 lg:text-xl">{data.users}</h4>
          <p className="text-xs mt-3 text-gray-600 font-semibold">Users</p>
          <span className="absolute top-4 text-blue-900 right-3">
            <UserIcon className="h-6 w-6" />
          </span>
        </div>
        <div className="bg-white cursor-pointer relative py-4 px-3 rounded-lg border-2 border-gray-300 shadow-sm">
          <h4 className="text-lg font-semibold text-gray-900 lg:text-xl">{data.neutrals}</h4>
          <p className="text-xs mt-3 text-gray-600 font-semibold">Neutrals</p>
          <span className="absolute top-4 text-blue-900 right-3">
            <UserPlusIcon className="h-6 w-6" />
          </span>
        </div>
        <div className="bg-white cursor-pointer relative py-4 px-3 rounded-lg border-2 border-gray-300 shadow-sm">
          <h4 className="text-lg font-semibold text-gray-900 lg:text-xl">{data.transactions}</h4>
          <p className="text-xs mt-3 text-gray-600 font-semibold">Pending Transactions</p>
          <span className="absolute top-4 text-blue-900 right-3">
            <CreditCardIcon className="h-6 w-6" />
          </span>
        </div>
        <div className="bg-white cursor-pointer relative py-4 px-3 rounded-lg border-2 border-gray-300 shadow-sm">
          <h4 className="text-lg font-semibold text-gray-900 lg:text-xl">{data.proceddings}</h4>
          <p className="text-xs mt-3 text-gray-600 font-semibold">Proceedings</p>
          <span className="absolute top-4 text-blue-900 right-3">
            <VideoCameraIcon className="h-6 w-6" />
          </span>
        </div>
      </div>
      <div className="mt-12 bg-white pt-3 rounded-lg">
        <div className="">
          <h4 className="mb-4 ml-4 text-sm font-semibold font-fira text-gray-800">Newly Joined User</h4>
          <div className="w-full overflow-x-scroll">
            <table className="min-w-max w-full table-auto">
              <thead className="text-xs font-fira bg-gray-200 rounded-t-lg">
                <tr>
                  <th className="py-3 px-8 text-left">Profile</th>
                  <th className="py-3 px-8 text-left">Date Joined</th>
                  <th className="py-3 px-8 text-left">Case Resolutions</th>
                  <th className="py-3 px-8 text-left">Status</th>
                  <th className="py-3 px-8 text-left"></th>
                </tr>
              </thead>
              <tbody>
                {Array.from(data.newlyJoinedUsers).map((user) => (
                  <tr key={user._id} className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <div className="flex gap-2 items-center justify-center">
                        <img src={user.avatar} alt="" className="w-8 h-8 rounded-full border-2 border-gray-200" />
                        <div>
                          <h4 className="text-xs font-semibold">{user.name}</h4>
                          <a className="text-xs text-blue-900" href={`mailto:${user.email}`}>{user.email}</a>
                        </div>
                      </div>
                    </td>
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <span>{moment(user.createdAt).fromNow()}</span>
                    </td>
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <span>{user.cases}</span>
                    </td>

                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <span className='text-green-900'>{user.verified ? 'Active' : 'Unverified'}</span>
                    </td>

                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <Link to={`/admin/user/${user._id}`} className='flex gap-1 items-center'>
                        <span>
                          <EyeIcon className="h-4 w-4" />
                        </span>
                        <span className='whitespace-nowrap'>See Profile</span>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div onClick={() => {
            navigate('/admin/users')
          }} className="py-3 text-xs hover:text-blue-900 cursor-pointer font-semibold font-fira w-full text-center">
            <span>View All Users</span>
          </div>
        </div>
      </div>

      <div className="mt-12 bg-white pt-3 rounded-lg">
        <div className="">
          <h4 className="mb-4 ml-4 text-sm font-semibold font-fira text-gray-800">Recent Transactions</h4>
          <div className="w-full overflow-x-scroll">
            <table className="min-w-max w-full table-auto">
              <thead className="text-xs font-fira bg-gray-200 rounded-t-lg">
                <tr>
                  <th className="py-3 px-8 text-left">User</th>
                  <th className="py-3 px-8 text-left">Amount</th>
                  <th className="py-3 px-8 text-left">Reference Code</th>
                  <th className="py-3 px-8 text-left">Payment Type</th>
                  <th className="py-3 px-8 text-left"></th>
                </tr>
              </thead>
              <tbody>
                {Array.from(data.recentTransactions).map((trx) => (
                  <tr key={trx._id} className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <div className="flex gap-2 items-center justify-center">
                        <img src={trx.user.avatar} alt="avatar" className="w-8 h-8 rounded-full border-2 border-gray-200" />
                        <div>
                          <h4 className="text-xs font-semibold">{trx.user.name}</h4>
                          <a className="text-xs text-blue-900" href={`mailto:${trx.user.email}`}>{trx.user.email}</a>
                        </div>
                      </div>
                    </td>
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <span>{trx.amount} {trx.currency}</span>
                    </td>
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <span>{trx.uid}</span>
                    </td>
                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <span className="capitalize">Bank Transfer</span>
                    </td>

                    <td className='py-3 px-8 text-left whitespace-nowrap'>
                      <button className='flex gap-1 items-center'>
                        <span>
                          <EyeIcon className="h-4 w-4" />
                        </span>
                        <span className='whitespace-nowrap'>View Transaction</span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        </div>
        <div onClick={() => {
          navigate('/admin/transactions')
        }} className="py-3 text-xs hover:text-blue-900 cursor-pointer font-semibold font-fira w-full text-center">
          <span>View All Transactions</span>
        </div>
      </div>
    </div>
  )
}
